import styled from "@emotion/styled";

export const StyledSidePaddings = styled.div`
  padding: 0 var(--horizontal-paddings);
`;
